import Approval from './approval.container'

export default Approval